import axios from 'axios'
import vm from '~/main'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    commonUserGrid: [],
    commonUserGridAll: [],
    commonUserSubscribersGrid: [],
    commonUserSubscribersAll: [],
    commonUserData: null,
    commonUserDataStatus: null,
    commonUserDataEmployee: null,
    pageData: null,
    commonUserAll: [],
    commonUserSearch: { data: [] },
  },
  mutations: {
    setCommonUserGrid(state, payload) {
      state.commonUserGrid = payload
    },
    setCommonUserSubscribersGrid(state, payload) {
      state.commonUserSubscribersGrid = payload
    },
    setCommonUserSubscribersAll(state, payload) {
      state.commonUserSubscribersAll = payload
    },
    setCommonUserGridAll(state, payload) {
      state.commonUserGridAll = payload
    },
    setCommonUserData(state, payload) {
      state.commonUserData = payload ? payload : null
    },
    setCommonUserDataStatus(state, payload) {
      state.commonUserDataStatus = payload
    },
    setCommonUserDataEmployee(state, payload) {
      state.commonUserDataEmployee = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setCommonUserAll(state, payload) {
      state.commonUserAll = payload
    },
    setCommonUserSearch(state, payload) {
      if (Object.keys(state.commonUserSearch).length) {
        for (let key of Object.keys(payload)) {
          if (key !== 'data') {
            vm.$set(state.commonUserSearch, key, payload[key])
          } else {
            console.log('search', {
              old: state.commonUserSearch.search,
              new: payload.search,
            })
            if (
              state.commonUserSearch.search == payload.search &&
              _.isEqual(state.commonUserSearch.ignoreIds, payload.ignoreIds)
            ) {
              vm.$set(state.commonUserSearch, key, [
                ...state.commonUserSearch[key],
                ...payload[key],
              ])
            } else {
              vm.$set(state.commonUserSearch, key, payload[key])
            }
          }
        }
      } else {
        state.commonUserSearch = payload
      }
    },
  },
  getters: {
    commonUserGrid: (state) => {
      return state.commonUserGrid.filter((i) => i.type !== 'superadmin')
    },
    commonUserGridAll: (state) => {
      return state.commonUserGridAll.filter((i) => i.type !== 'superadmin')
    },
    commonUserSubscribersGrid: (state) => {
      return state.commonUserSubscribersGrid.filter((i) => i.type !== 'superadmin')
    },
    commonUserSubscribersAll: (state) => {
      return state.commonUserSubscribersAll.filter((i) => i.type !== 'superadmin')
    },
    commonUserData: (state) => {
      return state.commonUserData
    },
    commonUserFullName: (state) => {
      return state.commonUserData.first_name + ' ' + state.commonUserData.last_name
    },
    commonUserDataStatus: (state) => {
      return state.commonUserDataStatus
    },
    commonUserDataEmployee: (state) => {
      return state.commonUserDataEmployee
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onCommonUserGrid({ commit, rootState }, { limit, page, filters, sort, search }) {
      let url =
        rootState.apiDomain +
        '/api/admin/common/user/grid?limit=' +
        limit +
        '&page=' +
        page +
        '&filter[]=type:null'
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=last_name:asc'
      }
      if (filters) url = url + filters
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setCommonUserGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonUserGridAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/common/user/grid?limit=0' +
            '&order[]=last_name:asc' +
            '&filter[]=type:null',
          method: 'GET',
        })
          .then((resp) => {
            commit('setCommonUserGridAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonUserSubscribersGrid({ commit, rootState }, { limit, page, filters, sort, search }) {
      let url =
        rootState.apiDomain +
        '/api/admin/common/user/grid?limit=' +
        limit +
        '&page=' +
        page +
        '&filter[]=type:subscriber'
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=last_name:asc'
      }
      if (filters) url = url + filters
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setCommonUserSubscribersGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonUserSubscribersAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/common/user/grid?limit=0' +
            '&filter[]=type:subscriber' +
            '&order[]=last_name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setCommonUserSubscribersAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonUserData({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/user/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setCommonUserDataStatus', resp.data.data.status)
            commit('setCommonUserDataEmployee', resp.data.data.employee !== null)
            commit('setCommonUserData', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonUserUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/user',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonUserBlock({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/user/block/' + id,
          id: id,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonUserUnblock({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/user/unblock/' + id,
          id: id,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonUserDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/user/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonUserDeleteConfirm({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/user/force/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    GET_commonUserSearch({ commit, rootState }, { limit, page, search, ignoreIds }) {
      let url =
        rootState.apiDomain +
        '/api/admin/common/user/search?limit=' +
        (limit || 10) +
        '&page=' +
        (page || 1) +
        '&search=' +
        (search || '')
      if (ignoreIds) {
        // console.log('ignoreIds', ignoreIds)
        for (let id of ignoreIds) {
          url = url + '&ignoreIds[]=' + id
        }
      }
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            resp.data.search = search === undefined ? '' : search
            resp.data.ignoreIds = ignoreIds === undefined ? [] : ignoreIds
            commit('setCommonUserSearch', resp.data)
            // commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    GET_commonUserAll({ commit, rootState }) {
      let url = rootState.apiDomain + '/api/admin/common/user/search?limit=0&page=1&includeSuperAdmin=1'
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setCommonUserAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
